<!--
 * @Description: 活动规则
 * @Author: yl
 * @Date: 2021-05-28 17:44:27
 * @LastEditTime: 2021-05-31 18:57:18
 * @LastEditors: yl
-->
<template>
    <div class="lotteryRulesArea">
        <div class="lotteryRules bv bc">
            <div class="img-rules bg-100 header"></div>
            <div class="rulesContent">
                <div class="bv" v-for="(item, i) in rulesContent" :key="i">
                    <span v-html="item"></span>
                </div>
            </div>
            <div class="img-notice bg-100 header"></div>
            <div class="noticeContent">
                <div class="bv" v-for="(item, i) in noticeContent" :key="i">
                    <span v-html="item"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    name: "",
    data() {
        return {
            rulesContent: [
                "1、每次抽奖完成，机会不再增加，随机出奖，抽奖所得 不支持退回。",
                '2、具体奖品使用信息如下：',
                '（1）车主币提现：车主币可拆分提现使用；',
                '（2）商城产品兑换：车主币可在商城购物使用，在付款时自动抵扣。',
                "<span style='color: #F33648;'>*车主币自获得后1年内有效，逾期未使用则自动失效</span>"
            ],
            noticeContent: [
                '在参与活动过程中，如用户出现作弊等违法违规行为，我们有权撤销用户参与活动及奖励使用资格，并有权收回用户已经获得的权益。'
            ]
        };
    }
};
</script>

<style scoped lang="scss">
.lotteryRulesArea {
    position: relative;
    top: 38px;
    height: 100%;
    overflow-y: scroll;
    .lotteryRules {
        margin-bottom: 260px;
        @include img-list("~@/assets/imges/lottery/", "rules", "notice");
        .header {
            height: 43px;
            width: 606px;
        }
        .rulesContent {
            width: 589px;
            font-size: 24px;
            color: #fc7b1d;
        }
        .noticeContent {
            width: 589px;
            font-size: 24px;
            color: #fc7b1d;
        }
    }
}
</style>